module.exports = {"370682001":"城厢街道","370682002":"古柳街道","370682003":"龙旺庄街道","370682004":"冯格庄街道","370682005":"柏林庄街道","370682101":"沐浴店镇","370682102":"团旺镇","370682103":"穴坊镇","370682104":"羊郡镇","370682105":"姜疃镇","370682106":"万第镇","370682107":"照旺庄镇","370682108":"谭格庄镇","370682110":"河洛镇","370682111":"吕格庄镇","370682112":"高格庄镇","370682113":"大夼镇","370682114":"山前店镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370682.json
// module id = 1406
// module chunks = 0